/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { AdvancedFilters } from "../../../../models/http/dashboard/advanced-filters.model";
import { ApplicationError } from "../../../../models/ui/application-error.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	GET_RESOURCES_EMISSIONS_RESPONSE,
	GET_TOP_10_EMISSIONS_RESPONSE,
	GET_TOTAL_CO2_EMISSIONS_RESPONSE
} from "./dashboard-component-emissions.db";

const CLASS_NAME = "DashboardComponentEmissions";

export class DashboardComponentEmissions {
	public static getTotalCo2Emissions(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getTotalCo2Emissions"
					)
			);

		return of(GET_TOTAL_CO2_EMISSIONS_RESPONSE);
	}

	public static getTop10Emissions(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getTop10Emissions"
					)
			);

		return of(GET_TOP_10_EMISSIONS_RESPONSE);
	}

	public static getResourcesEmissions(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getResourcesEmissions"
					)
			);

		return of(GET_RESOURCES_EMISSIONS_RESPONSE);
	}
}
